import { render, staticRenderFns } from "./GeneralSettingsContact.vue?vue&type=template&id=4c033b89&"
import script from "./GeneralSettingsContact.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports